import React from "react";

const End = () => {
  return <p className="end-text">Ab saalo chup rhna, nhi toh...</p>;
};

export default End;
